<template>  
  <div class="container"> 
     <h3> Configurações <span class="label label-warning">{{ this.status(filial) }}</span> </h3>
     <div class="col-lg-6" style="display:inline-block">
      <h4>Agenda</h4>
      <div class="form-group text-left">
        <label for="qtdeAssessores">Quantidade de Assessores</label>
        <input type="number" class="form-control" id="qtdeAssessores" placeholder="Quantidade de Assessores" v-model="configuracoes.QuantidadeAssessores">
      </div>
      <div class="form-group text-left">
        <label for="intervaloAtendimento">Intervalo de Atendimento <small>(em minutos)</small></label>
        <input type="number" class="form-control" id="intervaloAtendimento" placeholder="Intervalo de Atendimento" v-model="configuracoes.IntervaloAtendimento">
      </div>  
      <div class="form-group text-left">
        <label for="inicioAtendimento">Início Atendimento</label>
        <input type="text" class="form-control" id="inicioAtendimento" placeholder="Exemplo: 08:30" v-model="configuracoes.InicioAtendimento">
      </div>
      <div class="form-group text-left">
        <label for="fimAtendimento">Fim Atendimento</label>
        <input type="text" class="form-control" id="fimAtendimento" placeholder="Exemplo: 17:30" v-model="configuracoes.FimAtendimento">
      </div> 
      <div class="form-group text-left">
        <label for="fimAdmissao">Fim Atendimento Admissão</label>
        <input type="text" class="form-control" id="fimAdmissao" placeholder="Exemplo: 15:00" v-model="configuracoes.FimAdmissao" @blur="validaFimAdmissao">
      </div> 
      <div class="form-group text-left">
        <label for="BloqueioAgendaInicio">Bloquear Agenda Início</label>
        <input type="text" class="form-control" id="BloqueioAgendaInicio" placeholder="Exemplo: 12:00" v-model="configuracoes.BloqueioAgendaInicio">
      </div> 
      <div class="form-group text-left">
        <label for="BloqueioAgendaFim">Bloquear Agenda Fim</label>
        <input type="text" class="form-control" id="BloqueioAgendaFim" placeholder="Exemplo: 13:00" v-model="configuracoes.BloqueioAgendaFim" @blur="validaBloqueioFim">
      </div> 
      <div class="form-group text-right"> 
        <button type="button" class="btn btn-primary text-right" @click="submit"><i class="fa fa-save" aria-hidden="true" ></i> Salvar</button>
      </div>      
    </div>
    <div class="col-lg-6" style="display:inline-block">
      <h4>Planejamento Assessores</h4>
      <div class="form-group text-left col-lg-6">
        <label for="Data">Dia</label>
        <input type="date" class="form-control" id="Data" placeholder="Data" v-model="assessor.Data">
      </div> 
      <div class="form-group text-left col-lg-6">
        <label for="quantidade">Assessores disponíveis no Dia</label>
        <input type="number" class="form-control" id="quantidade" placeholder="Quantidade de Assessores" v-model="assessor.QuantidadeAssessores">
      </div>
      <div class="form-group text-left col-lg-12">
        <label for="Motivo">Motivo <small>(opcional)</small></label>
        <textarea class="form-control" rows="2" id="Motivo" v-model="assessor.Motivo" maxlength="150"></textarea>
        <!-- <small style="font-style:italic">Caracteres restantes: {{150 - assessoresDias.Motivo.length}} </small>  -->
      </div> 
      <div class="form-group text-right col-lg-12"> 
        <button type="button" class="btn btn-primary text-right" @click="salvaAssessoresDisponiveisDia"><i class="fa fa-save" aria-hidden="true" ></i> Salvar</button>
      </div>  
      <div class="col-lg-12" style="overflow-y: scroll; min-height:335px; max-height:335px">
        <table class="table table-responsive table-striped">
          <thead>
            <tr>
              <td></td>
              <td>Data</td>
              <td>Nº Assessores</td>
              <td>Motivo</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c of assessoresDias" :key="c">
              <td> <a href="#" style="color:red;" @click.prevent="deletarAssessorDisponivelDia(c.Id)" > <i class="fa fa-close" aria-hidden="true" ></i> </a> </td>
              <td>{{formatarData(c.Data)}}</td>
              <td>{{c.QuantidadeAssessores}}</td>
              <td>{{c.Motivo}}</td>
            </tr> 
          </tbody>
        </table>
      </div>
    </div>
    <Historico  style="display:inline-block" />
  </div>
</template>
<script>
import Historico from './shared/configuracoes/Historico'
import moment from 'moment'
export default {
  components: {
    Historico,
    moment
  },
  methods: {
    formatarData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    get () {
      this.$http.get('agenda/configuracoes?unidade=' + parseInt(localStorage.getItem('Unidade')))
      .then(function (res) {
        this.configuracoes = res.body
      })
    },
    salvaAssessoresDisponiveisDia () {
      this.assessor.UnidadeLuandre = parseInt(localStorage.getItem('Unidade'))
      this.assessor.IdUsuario = JSON.parse(localStorage.getItem('Usuario')).Usuario.Id

      this.$http.post('agenda/configurar/atendentes/dia', this.assessor)
      .then(function (res) {
        alert('Registro adicionado com sucesso')
        this.listarAssessoresDisponiveisDia()
      })
    },
    deletarAssessorDisponivelDia (id) {
      this.$http.delete('agenda/atendentes/dias/delete?id=' + id)
      .then(function (res) {
        alert('Registro excluído com sucesso')
        this.listarAssessoresDisponiveisDia()
      })
    },
    listarAssessoresDisponiveisDia () {
      this.$http.get('agenda/listar/atendentes/dias?unidade=' + parseInt(localStorage.getItem('Unidade')))
      .then(function (res) {
        this.assessoresDias = res.body
      })
    },
    validaFimAdmissao: function () {
      if (this.configuracoes.FimAdmissao > this.configuracoes.FimAtendimento) {
        alert('O horário de atendimento de admissão não pode ser maior que o horário de Fim de Atendimento')
        this.configuracoes.FimAdmissao = ''
      }
    },
    validaBloqueioFim: function () {
      if (this.configuracoes.BloqueioAgendaFim > this.configuracoes.FimAtendimento) {
        alert('O horário de bloqueio da agenda não pode ser maior que o horário de Fim de Atendimento')
        this.configuracoes.BloqueioAgendaFim = ''
      }
    },
    status (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Matriz'
          break
        case 1:
          escrito = 'ABC'
          break
        case 2:
          escrito = 'Alphaville'
          break
        case 4:
          escrito = 'Campinas'
          break
        case 5:
          escrito = 'Curitiba'
          break
        case 6:
          escrito = 'Faria Lima'
          break
        case 7:
          escrito = 'Guarulhos'
          break
        case 8:
          escrito = 'Jundiaí'
          break
        case 10:
          escrito = 'Rio de Janeiro'
          break
        case 11:
          escrito = 'Santo Amaro'
          break
        case 14:
          escrito = 'Recife'
          break
      }
      return escrito
    },
    submit () {
      this.configuracoes.UnidadeLuandre = parseInt(localStorage.getItem('Unidade'))
      this.configuracoes.IdUsuario = JSON.parse(localStorage.getItem('Usuario')).Usuario.Id

      this.$http.post('agenda/configurar', this.configuracoes)
      .then(function (res) {
        alert('Unidade configurada com sucesso')
      })
    }
  },
  created () {
    this.filial = parseInt(localStorage.getItem('Unidade'))
    this.get()
    this.listarAssessoresDisponiveisDia()
  },
  data () {
    return {
      filial: '',
      configuracoes: {},
      assessoresDias: [],
      assessor: {}
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Configuracoes.vue?42e9dcab